import SubscribeButton from '@/finsight/ui/components/deals/DealListTable/components/SubscribeButtonContainer';
import { ProfileTypes } from '@/finsight/application/actions/profile/constants';
import TogglingFilters from '@/finsight/ui/common/components/TogglingFilters';
import { useDealContext } from '@/finsight/application/Deal/DealContext';
import memoize from '@/Framework/dataHelpers/memoize';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import { IDealsHeaderProps } from '@/finsight/ui/components/deals/DealListTable/components/DealHeader';
import keyResolver from '@/Framework/dataHelpers/keyResolver';

import styles from '@/finsight/ui/components/deals/DealListTable/components/HeaderActions/headerActions.scss';

type HeaderActionsProps = Pick<IDealsHeaderProps, 'profileType' | 'showDealStatusFilters'>;

const getDealIds = memoize((deals) => deals.map((deal) => deal.id) || [], keyResolver);

export const HeaderActions = ({
  showDealStatusFilters = true,
  profileType,
}: HeaderActionsProps) => {
  const {
    collection,
    isFetching,
    subscribeButtonText,
    subscribeSuccessMessage,
    subscriptions,
    filterStatusSet,
    applyDealStatus,
  } = useDealContext();
  const {
    includedProductIds,
    includedRegionIds,
  } = usePageFiltersContext();
  const { subscriptionRequiredPlan } = subscriptions || {};
  const dealIds = getDealIds(collection);
  const isAllStatusesSelected = filterStatusSet.dealStatus.items.every((item) => item.isActive);
  const [productId] = includedProductIds;
  const [regionId] = includedRegionIds;
  const dealIdsLength = dealIds.length;
  const hasDeals = dealIdsLength !== 0;
  const noData = !hasDeals && !isFetching;

  return (
    <div className={ styles.headerActions }>
      <SubscribeButton
        label={ subscribeButtonText }
        successMessage={ subscribeSuccessMessage }
        isSubscribeAvailable={ !!(regionId && productId && profileType === ProfileTypes.OVERVIEW) }
        requiredPlan={ subscriptionRequiredPlan }
      />
      { showDealStatusFilters && (
        <div className={ styles.dealStatusFiltersWrapper }>
          <TogglingFilters
            isDisabled={ isFetching || (noData && isAllStatusesSelected) }
            applyFilter={ applyDealStatus }
            filterSet={ filterStatusSet }
            isTooltipEnabled={ false }
            activeClassName={ styles.dealStatusFiltersActive }
          />
        </div>
      ) }
    </div>
  );
};
